export default {"src":"/_next/static/media/edit-report-icon.b0cac86b.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};